import { NavigationResolution } from '@unifyapps/defs/types/interface';
import { EMPTY_OBJECT } from '../../../../../consts/empty';
import { DEFAULT_NAVIGATION_ITEM_APPEARANCE } from '../../../constants';
import {
  type BottomNavProps,
  NavigationItemLabelVariantEnum,
  type NavigationStylesType,
} from '../../../types';
import useAppSideNavState from '../../SideNavigation/hooks/useAppSideNavState';
import { useBottomNavItems } from './useBottomNavItems';

export function useBottomNavigation(props: BottomNavProps) {
  const {
    disableHoverListeners,
    controlledState,
    navigationClassNames,
    navigationProps,
    navigationStyles,
    pathname,
    projectSlug,
  } = props;

  const {
    navigationItemAppearance,
    navigation: _navigation,
    theme,
    position,
    resolution = NavigationResolution.XL,
  } = navigationProps;
  const { className, heightClassName, rootClassName } = navigationClassNames;
  const { style, heightStyles } = navigationStyles ?? (EMPTY_OBJECT as NavigationStylesType);

  const { labelVariant, selectionVariant } =
    navigationItemAppearance ?? DEFAULT_NAVIGATION_ITEM_APPEARANCE;

  const { expanded, activeMenuItemId, setActiveMenuItemId, hoverProps } = useAppSideNavState({
    disableHoverListeners:
      labelVariant !== NavigationItemLabelVariantEnum.Expandable || disableHoverListeners,
    controlledState,
  });

  const { activePathnames, adaptedNavItems, hasActiveNavItem } = useBottomNavItems({
    navigation: _navigation,
    pathname,
    projectSlug,
  });

  const slotProps = {
    navigationItem: {
      expanded,
      labelVariant,
      selectionVariant,
      position,
      resolution,
    },
  };

  return {
    slotProps,
    adaptedNavItems,
    hasActiveNavItem,
    activePathnames,
    activeMenuItemId,
    setActiveMenuItemId,
    hoverProps,
    theme,
    heightClassName,
    rootClassName,
    className,
    heightStyles,
    style,
  };
}
